module.exports = {
	"classes": [
		"financial-page",
		"header-dark"
	],
	"title": "Financial Sevices",
	"metas": {
		"description": "Digital transformation in Insurance and banking institutions starts with identity management. Build on IAM capabilities to improve the digital customer experience, securely collaborate with partners and stay compliant with regulations."
	},
	"opengraph": {
		"og:title": "Financial Sevices",
		"og:description": "Digital transformation in Insurance and banking institutions starts with identity management. Build on IAM capabilities to improve the digital customer experience, securely collaborate with partners and stay compliant with regulations.",
		"og:url": "https://auth0.com/financial-services",
		"og:image": "https://cdn.auth0.com/website/financial/images/financial-twitter-card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/financial/images/financial-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Financial Sevices",
		"twitter:description": "Digital transformation in Insurance and banking institutions starts with identity management. Build on IAM capabilities to improve the digital customer experience, securely collaborate with partners and stay compliant with regulations.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/financial/images/financial-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/financial-services/metadata.json
// module id = 1386
// module chunks = 0